



import {
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'HomePage',
  components: {
  },
  beforeRouteEnter: (_to, _from, next) => {
    next('/ConfirmAuthentication/intro');
  },
  setup() {

    return {
    };
  },
});
